import { Link } from "react-router-dom";
import { mangaCategories, latestManga } from "@/mocks/manga";

const latestCoverImages = [
  "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20featuring%20dark-haired%20hunter%20with%20blue%20eyes%20in%20black%20combat%20outfit%2C%20holographic%20system%20UI%20elements%2C%20dark%20gradient%20background%2C%20premium%20illustration&width=600&height=800&seq=latest-manga-cover-01&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Romantic%20manga%20cover%20with%20young%20couple%20in%20school%20uniforms%20under%20cherry%20blossoms%2C%20soft%20pink%20lighting%2C%20dreamy%20atmosphere%2C%20clean%20white%20background%2C%20beautiful%20shoujo%20art&width=600&height=800&seq=latest-manga-cover-02&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Epic%20fantasy%20manga%20young%20martial%20artist%20in%20red%20robes%20with%20flames%2C%20golden%20crimson%20tones%2C%20clean%20background%20with%20smoke%2C%20detailed%20illustration&width=600&height=800&seq=latest-manga-cover-03&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Romantic%20vampire%20manga%20cover%20handsome%20male%20vampire%20crimson%20eyes%20black%20attire%20gentle%20girl%20white%20dress%2C%20gothic%20rose%20garden%2C%20moonlight%2C%20deep%20red%20silver%20palette%2C%20exquisite%20art&width=600&height=800&seq=latest-manga-cover-04&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20beautiful%20girl%20flawless%20makeup%20two%20handsome%20male%20leads%2C%20modern%20Korean%20high%20school%2C%20pastel%20pink%20coral%20tones%2C%20glamorous%20aesthetic%2C%20bright%20background%2C%20webtoon%20style&width=600&height=800&seq=latest-manga-cover-05&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Xianxia%20manga%20young%20cultivator%20mountain%20peak%20mythical%20beasts%20clouds%2C%20golden%20sunrise%2C%20breathtaking%20fantasy%20landscape%2C%20traditional%20Chinese%20ink%20style%20modern%20manga%20rendering&width=600&height=800&seq=latest-manga-cover-06&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Post-apocalyptic%20Chinese%20manga%20futuristic%20soldier%20mechanical%20armor%20floating%20fortress%2C%20dramatic%20orange%20gray%20sky%20lightning%2C%20sci-fi%20dystopian%2C%20dark%20industrial%20background%2C%20mecha%20detail&width=600&height=800&seq=latest-manga-cover-07&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Action%20manga%20silver-haired%20gamer%20black%20jacket%20intense%20expression%2C%20neon%20gaming%20aesthetics%20blue%20orange%20accents%2C%20dark%20background%20digital%20particles%2C%20dynamic%20shonen%20art&width=600&height=800&seq=latest-manga-cover-08&orientation=portrait",
];

const categoryColors = [
  "bg-primary-500",
  "bg-secondary-500",
  "bg-primary-600",
  "bg-accent-500",
  "bg-foreground-800",
  "bg-secondary-600",
  "bg-primary-500",
  "bg-accent-600",
  "bg-foreground-700",
];

export default function LatestUpdate() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-start gap-6 mb-12">
          <div className="lg:w-[35%]">
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-foreground-900 leading-tight">
              最新<span className="block">更新</span>
            </h2>
          </div>
          <div className="lg:w-[65%]">
            <p className="text-sm text-foreground-500 leading-relaxed max-w-lg">
              每天第一时间更新最新漫画章节，让你永远比其他人更快看到精彩内容。热门连载、新作上线，应有尽有。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="md:col-span-1">
            <Link
              to="/category/all"
              className="group block relative aspect-[4/5] rounded-2xl overflow-hidden bg-foreground-900 cursor-pointer"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20illustration%20featuring%20multiple%20characters%20in%20dramatic%20poses%2C%20romantic%20and%20action%20scenes%20blended%20together%2C%20dark%20background%20with%20vibrant%20color%20accents%2C%20cinematic%20composition%2C%20premium%20webtoon%20art%20style&width=600&height=800&seq=featured-hanman-category&orientation=portrait"
                alt="无遮挡韩漫"
                title="无遮挡韩漫专区 - 汗汗漫画"
                className="absolute inset-0 w-full h-full object-cover object-top opacity-60 group-hover:opacity-80 transition-opacity duration-500"
              />
              <div className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center">
                <h3 className="text-2xl md:text-3xl font-black text-white font-heading">
                  无遮挡韩漫
                </h3>
                <p className="mt-3 text-sm text-white/70">
                  原汁原味韩国漫画完整呈现
                </p>
                <span className="mt-6 inline-block px-6 py-2.5 bg-white text-foreground-900 text-sm font-semibold rounded-full whitespace-nowrap">
                  进入专区
                </span>
              </div>
            </Link>
          </div>

          {latestManga.slice(0, 6).map((manga, index) => (
            <Link
              key={manga.id}
              to={`/article/${manga.id}`}
              className="group block bg-background-50 rounded-2xl overflow-hidden cursor-pointer hover:bg-background-100 transition-colors"
            >
              <div className="relative p-4">
                <div className="flex items-start gap-1.5 mb-3">
                  <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] font-medium bg-primary-100 text-primary-700 whitespace-nowrap">
                    <i className="ri-time-line text-[10px]"></i>
                    {manga.status}
                  </span>
                </div>
                <div className="aspect-[3/4] rounded-xl overflow-hidden mb-4">
                  <img
                    src={latestCoverImages[index]}
                    alt={manga.title}
                    title={`${manga.title} - 汗汗漫画`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <h3 className="text-lg font-bold text-foreground-900 font-heading leading-tight truncate">
                  {manga.title}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-500 truncate">
                  {manga.latestChapter}
                </p>
                <p className="mt-2 flex items-center gap-3 text-xs text-foreground-400">
                  <span>{manga.author}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-400 text-[10px]"></i>
                    {manga.rating}
                  </span>
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-16">
          <h4 className="text-lg font-bold text-foreground-900 font-heading mb-6">
            热门分类
          </h4>
          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-9 gap-2 md:gap-3">
            {mangaCategories.map((cat, index) => (
              <Link
                key={cat.slug}
                to="/category/all"
                className={`flex flex-col items-center gap-2 p-3 md:p-4 rounded-xl transition-all cursor-pointer hover:scale-105 ${categoryColors[index]} text-white`}
              >
                <span className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center">
                  <i className={`${cat.icon} text-lg md:text-xl`}></i>
                </span>
                <span className="text-xs md:text-sm font-medium whitespace-nowrap">{cat.name}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}